import React from 'react';

function DressCodeModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>
                <div className="ornament-top"></div>
                <h2 className="modal-title">Dress Code: Elegante</h2>
                <div className="divider"></div>
                <div className="modal-body">
                    <p className="modal-text">
                        Per questa serata speciale, vi chiedo di presentarvi con un abbigliamento <strong>elegante</strong>,
                        adatto a celebrare un traguardo così importante.
                    </p>
                    <div className="dress-code-suggestions">
                        <div className="suggestion-box">
                            <span className="suggestion-icon">👔</span>
                            <h3>Per Lui</h3>
                            <p style={{ fontSize: '0.95rem', marginBottom: '10px', fontWeight: '800' }}>Esempi di outfit:</p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Abito completo elegante (giacca e pantalone abbinati)</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Camicia elegante con cravatta o papillon</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Scarpe di cuoio lucide</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Accessori: gemelli, orologio raffinato</li>
                            </ul>
                        </div>
                        <div className="suggestion-box">
                            <span className="suggestion-icon">👗</span>
                            <h3>Per Lei</h3>
                            <p style={{ fontSize: '0.95rem', marginBottom: '10px', fontWeight: '800' }}>Esempi di outfit:</p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left' }}>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Abito lungo , midi elegante, abito corto</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Tailleur raffinato o jumpsuit elegante</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Scarpe con tacco o eleganti</li>
                                <li style={{ padding: '8px 0', paddingLeft: '20px', position: 'relative' }}>Accessori: clutch, gioielli raffinati</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="ornament-bottom"></div>
            </div>
        </div>
    );
}

export default DressCodeModal;
